/** School IDs with an active employee_schools assignment for this expert. */
export async function fetchActiveAssignedSchoolIdsForExpert(supabase, userId) {
	const { data, error } = await supabase
		.from("employee_schools")
		.select("school_id")
		.eq("profile_id", userId)
		.eq("active_status", true);

	if (error) throw error;

	return (data || []).map((row) => row.school_id).filter(Boolean);
}

/** School IDs linked to a Funmath Expert via ownership or visits. */
export async function fetchSchoolIdsLinkedToExpert(supabase, userId) {
	const schoolIds = new Set();

	const { data: employeeSchools, error: employeeError } = await supabase
		.from("employee_schools")
		.select("school_id")
		.eq("profile_id", userId)
		.eq("active_status", true);

	if (!employeeError && employeeSchools) {
		employeeSchools.forEach((row) => {
			if (row.school_id) schoolIds.add(row.school_id);
		});
	}

	const { data: plannedVisits, error: plannedError } = await supabase
		.from("school_visits")
		.select("school_id")
		.eq("planned_by", userId);

	if (!plannedError && plannedVisits) {
		plannedVisits.forEach((visit) => {
			if (visit.school_id) schoolIds.add(visit.school_id);
		});
	}

	const { data: visitedSchools, error: visitedError } = await supabase
		.from("school_visits")
		.select("school_id")
		.eq("visited_by", userId);

	if (!visitedError && visitedSchools) {
		visitedSchools.forEach((visit) => {
			if (visit.school_id) schoolIds.add(visit.school_id);
		});
	}

	return Array.from(schoolIds);
}

export function isActiveSchool(school) {
	return (school?.status || "Active") === "Active";
}

export function filterActiveSchools(schools = []) {
	return schools.filter(isActiveSchool);
}

export async function fetchActiveSchoolsForExpert(supabase, userId) {
	const linkedIds = await fetchSchoolIdsLinkedToExpert(supabase, userId);
	if (linkedIds.length === 0) {
		return [];
	}

	const { data, error } = await supabase
		.from("schools")
		.select("id, name, district, status, school_type_id, school_types(id, name)")
		.in("id", linkedIds)
		.eq("status", "Active")
		.order("name");

	if (error) throw error;
	return data || [];
}
